export class Proposal {
    id: number;
    uniqueId: string;
    title: string;
    proposalResultItems: ProposalItem[]
}

export class ProposalItem {
    id: number;
    uniqueId: string;
    result: string;
}
